<template>

    <div>
        <rkm-row>
            <rkm-col cols="4">
                <rkm-area
                    title="Avaliação antropométrica"
                    type="fieldset"
                >

                    <rkm-row>

                        <rkm-col cols="6">
                            <rkm-form-input
                                label="Peso (kg)"
                                v-model="data.model.atendimento.peso"
                                :mask="maskPeso"
                                :validations="validations.peso"
                                :disabled="isDisabled() || isDisabledTipo()"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-input
                                label="Altura (cm)"
                                v-model="data.model.atendimento.altura"
                                :mask="maskAltura"
                                :validations="validations.altura"
                                :disabled="isDisabled() || isDisabledTipo()"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-area
                    title="Sinais vitais"
                    type="fieldset"
                >

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-input
                                label="Aferição de PA"
                                :mask="maskPressao"
                                v-model="data.model.atendimento.afericaoPa"
                                :validations="validations.afericaoPa"
                                :disabled="isDisabled() || isDisabledTipo()"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-input
                                label="Temperatura (ºC)"
                                v-model="data.model.atendimento.temperatura"
                                :validations="validations.temperatura"
                                :disabled="isDisabled() || isDisabledTipo()"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-area
                    title="Glicemia"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-input
                                label="Glicemia"
                                v-model="data.model.atendimento.glicemia"
                                :validations="validations.glicemia"
                                :disabled="isDisabled() || isDisabledTipo()"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-select
                                :options="data.form.momentoColeta"
                                :disabled="isDisabled() || isDisabledTipo()"
                                :validations="validations.momentoColeta"
                                label="Momento da coleta"
                                show-default-option
                                text-field="descricao"
                                v-model="data.model.atendimento.momentoColetaId"
                                default-option-text="Selecione"
                                value-field="id"
                                class="pt-0"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-area
            title="Desfecho *"
            type="fieldset"
        >

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-radio-group
                        v-model="data.model.atendimento.desfechoId"
                        name="desfecho"
                        :options="data.form.desfecho"
                        :validations="validations.desfecho"
                        text-field="descricao"
                        value-field="id"
                        @change="handleDesfecho"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            type="fieldset"
            title="Complemento"
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-textarea
                        v-model="data.model.complemento"
                        name="observacao"
                        rows="4"
                        max-rows="4"
                        :validations="validations.complemento"
                    >
                    </rkm-form-textarea>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>

//Enums
import desfecho from '@/enums/atencao-basica/visita-domiciliar/desfecho'
import tipoImovel from '@/enums/atencao-basica/cadastro-domiciliar/tipoImovel'

export default {
    computed: {
        validations() {

            return {
                complemento: { max: 1000 },
                desfecho: { required: true },
                peso: { min_value: 0.5, max_value: 500 },
                altura: { min_value: 20, max_value: 250 },
                temperatura: { min_value: 20, max_value: 45 },
                afericaoPa: { pressao_arterial: true, min_max_without_mask: [6] },
                glicemia: { required: this.data.model.atendimento.momentoColetaId ? true : false, min_value: 0, max_value: 800 },
                momentoColeta: { required: this.data.model.atendimento.glicemia ? true : false },
            }
        },
        maskPeso() {

            const value = this.data.model.atendimento.peso ?? null;

            if (value) {
                const decimalSeparatorIndex = value.indexOf('.') !== -1 ? value.indexOf('.') : value.indexOf(',');

                if (decimalSeparatorIndex !== -1) {

                    const valueLength = value.indexOf('.') !== -1
                        ? value.split(".")[0].length
                        : value.split(",")[0].length

                    if (valueLength === 1) {
                        return '#.###';
                    } else if (valueLength === 2) {
                        return '##.###';
                    }
                    else {
                        return '###.###';
                    }
                } else {
                    return '###';
                }
            }

            return '';
        },
        maskAltura() {

            const value = this.data.model.atendimento.altura ?? null;

            if (value) {
                const decimalSeparatorIndex = value.indexOf('.') !== -1 ? value.indexOf('.') : value.indexOf(',');

                if (decimalSeparatorIndex !== -1) {

                    const valueLength = value.indexOf('.') !== -1
                        ? value.split(".")[0].length
                        : value.split(",")[0].length

                    if (valueLength === 2) {
                        return '##.###';
                    }
                    else {
                        return '###.###';
                    }
                } else {
                    return '###';
                }
            }

            return '';
        },
        maskTemperatura() {

            return '##.#';
        },
        maskPressao() {

            const value = this.data.model.atendimento.afericaoPa ?? null;

            if (value) {
                const decimalSeparatorIndex = value.indexOf('/');

                if (decimalSeparatorIndex !== -1) {

                    const valueLength = value.split("/")[0].length

                    if (valueLength === 1) {
                        return '#/#####';
                    } else if (valueLength === 2) {
                        return '##/####';
                    }
                    else {
                        return '###/###';
                    }
                } else {
                    return '###/###';
                }
            }

            return '';
        },
    },
    data: () => ({
        enums: {
            desfecho,
            tipoImovel
        },
    }),
    methods: {
        setMotivos() {

            this.data.model.motivo.acompanhamento = []
            this.data.model.motivo.buscaAtiva = []
            this.data.model.motivo.controleAmbientalVetorial = []
            this.data.model.motivo.outroMotivo = []
            this.data.model.motivo.tipoVisita = []

            this.data.model.atendimento.peso = null
            this.data.model.atendimento.altura = null
            this.data.model.atendimento.afericaoPa = null
            this.data.model.atendimento.temperatura = null
            this.data.model.atendimento.glicemia = null
            this.data.model.atendimento.momentoColetaId = null
        },
        handleDesfecho() {

            if (this.data.model.atendimento.desfechoId == this.enums.desfecho.VISITA_RECUSADA
                || this.data.model.atendimento.desfechoId == this.enums.desfecho.AUSENTE) {

                    this.showConfirmation(
                        `Ao selecionar o desfecho Visita recusada ou o desfecho ausente, os motivos marcados serão
                            desmarcados e ficaram inativo. Deseja continuar?`,
                        async () => this.setMotivos(),
                        async () => this.data.model.atendimento.desfechoId = null
                    )
                }
        },
        isDisabled() {

            return this.data.model.atendimento.desfechoId == this.enums.desfecho.VISITA_RECUSADA
                || this.data.model.atendimento.desfechoId == this.enums.desfecho.AUSENTE
        },
        isDisabledTipo() {

            return this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.COMERCIO
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.TERRENO_BALDIO
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.PONTO_ESTRATEGICO
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.ESCOLA
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.CRECHE
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.ESTABELECIMENTO_RELIGIOSO
        }
    },
    props: {
        data: { type: Object, required: false, },
    },
}
</script>